/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Of_Landing_Presence_TitleInputs */

const en_of_landing_presence_title = /** @type {(inputs: Of_Landing_Presence_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See who is here`)
};

const id_of_landing_presence_title = /** @type {(inputs: Of_Landing_Presence_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat siapa yang hadir`)
};

/**
* | output |
* | --- |
* | "See who is here" |
*
* @param {Of_Landing_Presence_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const of_landing_presence_title = /** @type {((inputs?: Of_Landing_Presence_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Of_Landing_Presence_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_of_landing_presence_title(inputs)
	return en_of_landing_presence_title(inputs)
});